import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { AuthService } from '../auth/services/auth.service';
import { LoginPageModule } from '../auth/pages/login/login.module';
import { LoginPage } from '../auth/pages/login/login.page';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  
    constructor(private authService: AuthService, private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

      let comingLogin = state.url.includes('auth/login');

    if (this.authService.isAuthenticated()) {
      
      if(comingLogin) {
  
        this.router.navigate(['connectors']);
        return false;
      }
        return true;
    }
    else {

      if(comingLogin) {
        return true
      }

      this.router.navigate(['auth/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }
  }
}

